/**
 * Default url parameters for Dato images
 */
export const DATO_IMAGE_DEFAULT_PARAMS: Record<string, string> = {
  auto: 'format',
  crop: 'focalpoint',
  fit: 'crop',
  q: '85',
};
